export const VALID_TABLE_NAME_REGEXP = /^[a-z][a-z-_0-9]*$/;

export const VALID_FIELD_NAME_REGEXP = /^[a-z][a-z-_0-9]*$/;
